










































































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import Availability from '@/models/Workers/Availability';
import WorkerAvailabilityDetails from '@/components/Workers/WorkerAvailabilityDetails.vue';
import WorkerAvailabilityDetailsEdit from '@/components/Workers/WorkerAvailabilityDetailsEdit.vue';
import WorkerAvailabilityRestrictionEdit from '@/components/Workers/WorkerAvailabilityRestrictionEdit.vue';
import WorkerTempTransportDetailsEdit from '@/components/Workers/WorkerTempTransportDetailsEdit.vue';
import WorkerTempEmergencyDetailsEdit from '@/components/Workers/WorkerTempEmergencyDetailsEdit.vue';
import ListUtils from '@/lib/listUtils';
import AvailabilityRestrictionPeriodCreate from '@/components/AvailabilityRestrictionPeriods/AvailabilityRestrictionPeriodCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import AvailabilityRestrictionPeriodDto from '@/models/AvailabilityRestrictionPeriods/AvailabilityRestrictionPeriodDto';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';

@Component({
  name: 'WorkerDetails',
  components: { WorkerAvailabilityDetails, WorkerAvailabilityDetailsEdit, WorkerAvailabilityRestrictionEdit, AvailabilityRestrictionPeriodCreate, WorkerTempTransportDetailsEdit, WorkerTempEmergencyDetailsEdit }
})
export default class extends GiganautVue {

	availabilityRestrictionTypes = AvailabilityRestriction;

	isAvailableMonAM: boolean;  
	isAvailableMonPM: boolean;  
	isAvailableTueAM: boolean;  
	isAvailableTuePM: boolean;  
	isAvailableWedAM: boolean;  
	isAvailableWedPM: boolean;  
	isAvailableThuAM: boolean;  
	isAvailableThuPM: boolean;  
	isAvailableFriAM: boolean;  
	isAvailableFriPM: boolean;  
	isAvailableSatAM: boolean;  
	isAvailableSatPM: boolean;  
	isAvailableSunAM: boolean;  
	isAvailableSunPM: boolean; 
	
	get IsAvailableMonAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.MonAM)
	}
	set IsAvailableMonAM (isAvailable: boolean) {
		this.isAvailableMonAM = isAvailable
	}
	get IsAvailableTueAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.TueAM)
	}
	set IsAvailableTueAM (isAvailable: boolean) {
		this.isAvailableTueAM = isAvailable
	}
	get IsAvailableWedAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.WedAM)
	}
	set IsAvailableWedAM (isAvailable: boolean) {
		this.isAvailableWedAM = isAvailable
	}
	get IsAvailableThuAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.ThuAM)
	}
	set IsAvailableThuAM (isAvailable: boolean) {
		this.isAvailableThuAM = isAvailable
	}
	get IsAvailableFriAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.FriAM)
	}
	set IsAvailableFriAM (isAvailable: boolean) {
		this.isAvailableFriAM = isAvailable
	}
	get IsAvailableSatAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SatAM)
	}
	set IsAvailableSatAM (isAvailable: boolean) {
		this.isAvailableSatAM = isAvailable
	}
	get IsAvailableSunAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SunAM)
	}
	set IsAvailableSunAM (isAvailable: boolean) {
		this.isAvailableSunAM = isAvailable
	}
	get IsAvailableMonPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.MonPM)
	}
	set IsAvailableMonPM (isAvailable: boolean) {
		this.isAvailableMonPM = isAvailable
	}
	get IsAvailableTuePM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.TuePM)
	}
	set IsAvailableTuePM (isAvailable: boolean) {
		this.isAvailableTuePM = isAvailable
	}
	get IsAvailableWedPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.WedPM)
	}
	set IsAvailableWedPM (isAvailable: boolean) {
		this.isAvailableWedPM = isAvailable
	}
	get IsAvailableThuPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.ThuPM)
	}
	set IsAvailableThuPM (isAvailable: boolean) {
		this.isAvailableThuPM = isAvailable
	}
	get IsAvailableFriPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.FriPM)
	}
	set IsAvailableFriPM (isAvailable: boolean) {
		this.isAvailableFriPM = isAvailable
	}
	get IsAvailableSatPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SatPM)
	}
	set IsAvailableSatPM (isAvailable: boolean) {
		this.isAvailableSatPM = isAvailable
	}
	get IsAvailableSunPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SunPM)
	}
	set IsAvailableSunPM (isAvailable: boolean) {
		this.isAvailableSunPM = isAvailable
	}

	get currentWorker() {
		return WorkerDetailsModule.currentWorker;
	}

	get availabilityRestrictionPeriods() {
		return WorkerDetailsModule.currentWorker.availabilityRestrictionPeriods;
	}

	// Look up the display label for an enum int value. Shared lookup so the
	// read-only panel uses the same vocabulary as the edit dialog's <v-select>.
	private enumLabel(items: { name: string; value: number }[], value: number): string {
		const found = items.find(i => i.value === value);
		return found ? found.name : '—';
	}

	titleLabel(v: number): string { return this.enumLabel(ListUtils.titles(), v); }

	async deletePeriod(availabilityRestrictionPeriod: AvailabilityRestrictionPeriodDto) {
		const options: VuetifyConfirmObject = {
			buttonTrueText: "DELETE",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		};
		const result = await this.$confirm(
			"Are you sure you want to delete this period?",
			options
		);
		if (result) {
			await WorkerDetailsModule.deleteAvailabilityRestrictionPeriod(availabilityRestrictionPeriod);
		}
	}

	availabilityClass(isAvailable: boolean){
		if (isAvailable) {
			return "available";
		} 
		else {
			return "unavailable";
		}
	}

	private headers = [{ text: "Start", value: "startAt" }, { text: "End", value: "endAt" }, { text: "Actions" }];
}
